import Check from '@mui/icons-material/Check'
import CheckCircle from '@mui/icons-material/CheckCircle'
import Lock from '@mui/icons-material/Lock'
import dayjs from 'dayjs'
import { useEffect, useState } from 'react'
import { Spinner } from 'react-bootstrap'
import { toast } from 'react-toastify'
import { useScrollTo } from 'src/customHooks/customHooks'
import { getImageLink } from 'src/mentor/helpers/utilityFunctions'
import {
  ActivePlannedActivityBackdrop,
  CompletedActivityDiv,
  LockedInfoContainer,
  LockedPlannedActivityOverlay,
  UAPDayCompletionTick,
  UAPDayContentDivider,
  UAPDayContentDividerContainer,
  UAPDayHeading,
  UAPDayHeadingContainer,
  UAPDayProgressConnectorContainer,
  UAPDayThread,
  UAPTimePlanTitlesAndCheckBoxContainer,
  UserActivityPlanPhaseDayItemContainer,
  ViewActivityButton,
} from '../../MyPlanStyles'
import { canUserAccessThisActivity } from '../../user-activity-plan-helpers'
import PlannedActivityStartedComponent from '../PlannedActivityStartedComponent/PlannedActivityStartedComponent'
import { PlannedActivitiesLister } from './PlannedActivityLister'

export function PlannedActivityDayWiseListItem({
  planItem,
  planItemIndex,
  platItemsArray,
  selectedPhase,
  userActivity,
  UAPLogs,
  onClickPlannedActivity,
  isNotTablet,
  planPhaseListScrollRef,
  planItemListHasActiveItem,
  activityPlan,
  active,
  todaysActivityIndex,
  resetToTodaysActivity,
  setSelectedActivityIndex,
  setupData,
  selectedPlannedActivityDetails,
  startActivityProps,
  toggleActivityInfo,
}) {
  const [ref, setScrollToMe] = useScrollTo({ offset: 0 })
  const [starting, setStarting] = useState(false)

  const expandActivity = selectedPlannedActivityDetails?.index === planItemIndex

  const activityHasPassed =
    todaysActivityIndex > planItem?.planItemIdx ||
    UAPLogs?.find((log) => log.plannedActivityId === planItem?.id)?.activityCompleted ||
    false
  const activityIsLocked = todaysActivityIndex < planItem?.planItemIdx

  async function handleClickStartActivity() {
    setStarting(true)
    const canWeAccessThisActivity = await canUserAccessThisActivity(activityPlan, planItem)
    if (!!canWeAccessThisActivity) {
      onClickPlannedActivity({
        item: planItem,
        index: planItemIndex,
        signedUrls: canWeAccessThisActivity,
      })
    } else {
      toast.error('You cannot access this activity')
    }
    setStarting(false)
  }

  function renderActivityStartButton() {
    if (activityHasPassed) {
      return starting ? (
        <Spinner animation="border" variant="dark" />
      ) : (
        <CompletedActivityDiv>
          <span>Completed</span>
          <CheckCircle />
        </CompletedActivityDiv>
      )
    }
    if (activityIsLocked) {
      return (
        <ViewActivityButton key="locked" locked onClick={resetToTodaysActivity}>
          <span>Please complete today&apos;s activity to open this</span>
          <Lock />
        </ViewActivityButton>
      )
    }
    return (
      <ViewActivityButton
        key="star_act"
        onClick={handleClickStartActivity}
        sx={{ background: '#ffffff6b' }}
      >
        {starting ? <Spinner animation="border" variant="dark" /> : <span>Start Activity</span>}
      </ViewActivityButton>
    )
  }

  async function Setup() {
    // await sleep(150)
    if (active) {
      setScrollToMe(true)
      if (!activityIsLocked) {
        handleClickStartActivity()
      }
    } else {
      if (!planItemListHasActiveItem) {
        console.log('scrolling to top')
        planPhaseListScrollRef?.current?.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth',
        })
      }
    }
  }

  useEffect(() => {
    Setup()
  }, [planItemListHasActiveItem, active])

  return (
    <UserActivityPlanPhaseDayItemContainer
      ref={ref}
      active={active}
      customBackground={`url(${getImageLink(planItem?.coverImage)})`}
      noBorder={planItem?.noBorder}
      onClick={() => setSelectedActivityIndex && setSelectedActivityIndex(planItem?.planItemIdx)}
      clickable={active ? null : setSelectedActivityIndex}
    >
      {active && <ActivePlannedActivityBackdrop darker={activityIsLocked} />}
      {activityIsLocked && !active && (
        <LockedPlannedActivityOverlay>
          <LockedInfoContainer>
            <Lock sx={{ fontSize: '35px' }} />
          </LockedInfoContainer>
        </LockedPlannedActivityOverlay>
      )}
      <UAPTimePlanTitlesAndCheckBoxContainer>
        <UAPDayHeadingContainer passed={activityHasPassed}>
          <UAPDayHeading style={{ opacity: planItem?._hideDate ? 0 : 1 }}>
            <span>{dayjs(planItem?.estimatedCompletionDate).format('D MMM').split(' ')?.[1]}</span>
            <span>{dayjs(planItem?.estimatedCompletionDate).format('D MMM').split(' ')?.[0]}</span>
          </UAPDayHeading>
        </UAPDayHeadingContainer>
        <UAPDayContentDividerContainer style={{ opacity: planItem?._hideDate ? 0 : 1 }}>
          <UAPDayContentDivider />
        </UAPDayContentDividerContainer>
        <div className="d-flex flex-column gap-2 w-100">
          <PlannedActivitiesLister
            plannedActivity={planItem}
            active={active}
            passed={activityHasPassed}
            todaysActivityIndex={todaysActivityIndex}
            setupData={setupData}
            onClickInfoButton={toggleActivityInfo}
          />
        </div>
        {/* 
        <PlannedActivitiesLister
          plannedActivity={planItem}
          active={active}
          passed={activityHasPassed}
          todaysActivityIndex={todaysActivityIndex}
          setupData={setupData}
        /> */}

        {activityHasPassed ? (
          <UAPDayProgressConnectorContainer>
            <UAPDayThread hide={isNotTablet && selectedPhase?.firstDay + planItemIndex === 1} />
            <UAPDayCompletionTick>
              <Check />
            </UAPDayCompletionTick>
            <UAPDayThread />
          </UAPDayProgressConnectorContainer>
        ) : (
          <UAPDayProgressConnectorContainer></UAPDayProgressConnectorContainer>
        )}
      </UAPTimePlanTitlesAndCheckBoxContainer>
      {active && expandActivity && (
        <PlannedActivityStartedComponent
          planItem={planItem}
          signedUrls={{
            pre: selectedPlannedActivityDetails?.signedUrls,
            post: selectedPlannedActivityDetails?.signedUrls,
          }}
          {...startActivityProps}
          activityPlan={activityPlan}
          planItemIdx={planItemIndex}
          activityHasPassed={activityHasPassed}
        />
      )}
      {active && !expandActivity && renderActivityStartButton()}
    </UserActivityPlanPhaseDayItemContainer>
  )
}

// const activityIsLocked = checkIfPlannedActivityIsLocked(
//   selectedPhase,
//   planItemIndex,
//   userActivity,
//   UAPLogs,
//   planItem,
// )
